// TripBookTab.tsx
import React from "react";

interface TripBookTabProps {
    tripBookUrl: string | undefined;
}

export const TripBookTab: React.FC<TripBookTabProps> = ({ tripBookUrl }) => {
    return (
        <div className="w-full h-full pt-16 bg-white">
            {tripBookUrl ? (
                <iframe
                    src={tripBookUrl}
                    title="TripBook"
                    className="w-full h-full border-0"
                    allowFullScreen
                ></iframe>
            ) : (
                <div className="flex items-center justify-center h-full">
                    <p className="text-xl text-gray-500">No hay TripBook disponible para este itinerario.</p>
                </div>
            )}
        </div>
    );
};
